// @material-ui/icons
import AcUnitIcon from "@material-ui/icons/AcUnit";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";
import WhatshotIcon from "@material-ui/icons/Whatshot";

export const upcomingEvents = [];

export const previousEvents = [
    {
        Icon: WhatshotIcon,
        label: "HEAT 2020",
        path: "/heat-2020",
    },
    {
        Icon: AcUnitIcon,
        label: "ERUPT 2020",
        path: "/erupt-2020",
    },
    {
        Icon: BeachAccessIcon,
        label: "SWIFT 2020",
        path: "/swift-2020",
    },
];
